import { render, staticRenderFns } from "./FieldCustomIconButtons.vue?vue&type=template&id=641bf15a&scoped=true"
import script from "./FieldCustomIconButtons.vue?vue&type=script&lang=js"
export * from "./FieldCustomIconButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641bf15a",
  null
  
)

export default component.exports